export enum Podcast {
    Alexosigge = "Alexosigge",
}
